"use client";

import { ArrowRight as ArrowIcon } from "lucide-react";
import Link from "@components/Link";
import { useHeaderContext } from "@context/headerContext";
import { useUspAnimation, uspAnimationVariants } from "@hooks/useUspAnimation";
import { AnimatePresence, m } from "framer-motion";
import { useMemo } from "react";

const LeftLinks = () => {
  const { locale, leftLinksCollection } = useHeaderContext();
  const total = useMemo(
    () => leftLinksCollection?.items?.length ?? 0,
    [leftLinksCollection?.items],
  );

  const { setIsAnimationPlaying, currentSlide } = useUspAnimation({
    total,
  });

  if (!leftLinksCollection?.items?.length) return null;

  return (
    <div className="max-xs:text-xs mx-auto flex flex-1 items-center overflow-hidden font-normal">
      <AnimatePresence initial={false} mode="popLayout" presenceAffectsLayout>
        {leftLinksCollection.items.map((item, index) => {
          if (!item?.title) return null;
          if (index !== currentSlide) return null;

          return (
            <m.div
              className="lg:border-x-color-base flex grow border-x-transparent text-center max-lg:justify-center"
              key={item.sys.id + index}
              variants={uspAnimationVariants}
              initial="enter"
              animate="center"
              exit="exit"
              onHoverStart={() => setIsAnimationPlaying(false)}
              onHoverEnd={() => setIsAnimationPlaying(true)}
            >
              <Link
                key={item.sys.id + index}
                href={item.externalLink ?? item.internalLink?.slug}
                locale={locale}
                className="flex items-center gap-x-1 px-3 whitespace-nowrap hover:underline"
                target={item.openInNewTab ? "_blank" : undefined}
              >
                {item.title}
                <ArrowIcon strokeWidth={1} className="size-4" />
              </Link>
            </m.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

LeftLinks.displayName = "LeftLinks";

export default LeftLinks;
